module.exports = __webpack_public_path__ + "img/sv.26ee8872.svg";